import React from "react";
import { validateEmail } from "../../../sso/validators/text-validators";

const RandomSeedMaxValue = 10000000;

export default class ContactInfoStep extends React.Component {
    constructor(props) {
        super(props);

        const { emailAddress, initialResult } = this.props;
        const {
            firstnameField,
            lastnameField,
            checkbox1Field,
            checkbox2Field,
            additionalField1,
            additionalField2,
        } = this.props.options;

        const result = initialResult ? initialResult : {};

        this.state = {
            randomSeedNumber: Math.floor(Math.random() * RandomSeedMaxValue),
            firstName: result[firstnameField] ? result[firstnameField] : "",
            lastName: result[lastnameField] ? result[lastnameField] : "",
            additional1: result[additionalField1]
                ? result[additionalField1]
                : "",
            additional2: result[additionalField2]
                ? result[additionalField2]
                : "",
            emailAddress: emailAddress ? emailAddress : "",
            agreedToC1: result[checkbox1Field] ? result[checkbox1Field] : false,
            agreedToC2: result[checkbox2Field] ? result[checkbox2Field] : false,
        };

        this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
        this.handleLastnameChange = this.handleLastnameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleCheckbox1Change = this.handleCheckbox1Change.bind(this);
        this.handleCheckbox2Change = this.handleCheckbox2Change.bind(this);
        this.handleAdditional1Change = this.handleAdditional1Change.bind(this);
        this.handleAdditional2Change = this.handleAdditional2Change.bind(this);

        this.isValid = this.isValid.bind(this);

        this.updateResult = this.props.updateResult;
    }

    isValid() {
        const {
            nameFieldsAreOptional,
            hideNameFields,
            checkbox1IsOptional,
            hideCheckbox1,
            checkbox2IsOptional,
            hideCheckbox2,
            additionalField1IsOptional,
            hideAdditionalField1,
            additionalField2IsOptional,
            hideAdditionalField2,
        } = this.props.options;

        const {
            firstName,
            lastName,
            emailAddress,
            agreedToC1,
            agreedToC2,
            additional1,
            additional2,
        } = this.state;

        return (
            (nameFieldsAreOptional ||
                hideNameFields ||
                (firstName !== "" && lastName !== "")) &&
            validateEmail(emailAddress).isValid &&
            (checkbox1IsOptional || hideCheckbox1 || agreedToC1 === true) &&
            (checkbox2IsOptional || hideCheckbox2 || agreedToC2 === true) &&
            (additionalField1IsOptional ||
                hideAdditionalField1 ||
                additional1 !== "") &&
            (additionalField2IsOptional ||
                hideAdditionalField2 ||
                additional2 !== "")
        );
    }

    handleFirstnameChange(event) {
        this.setState({
            randomSeedNumber: this.state.randomSeedNumber,
            firstName: event.target.value,
            lastName: this.state.lastName,
            emailAddress: this.state.emailAddress,
            agreedToC1: this.state.agreedToC1,
            agreedToC2: this.state.agreedToC2,
            additional1: this.state.additional1,
            additional2: this.state.additional2,
        });

        const { firstnameField } = this.props.options;

        this.updateResult(this.isValid(), firstnameField, event.target.value);
    }

    handleLastnameChange(event) {
        this.setState({
            randomSeedNumber: this.state.randomSeedNumber,
            firstName: this.state.firstName,
            lastName: event.target.value,
            emailAddress: this.state.emailAddress,
            agreedToC1: this.state.agreedToC1,
            agreedToC2: this.state.agreedToC2,
            additional1: this.state.additional1,
            additional2: this.state.additional2,
        });

        const { lastnameField } = this.props.options;

        this.updateResult(this.isValid(), lastnameField, event.target.value);
    }

    handleEmailChange(event) {
        this.setState({
            randomSeedNumber: this.state.randomSeedNumber,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailAddress: event.target.value,
            agreedToC1: this.state.agreedToC1,
            agreedToC2: this.state.agreedToC2,
            additional1: this.state.additional1,
            additional2: this.state.additional2,
        });

        this.updateResult(this.isValid(), "emailAddress", event.target.value);
    }

    handleCheckbox1Change(event) {
        this.setState({
            randomSeedNumber: this.state.randomSeedNumber,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailAddress: this.state.emailAddress,
            agreedToC1: event.target.checked,
            agreedToC2: this.state.agreedToC2,
            additional1: this.state.additional1,
            additional2: this.state.additional2,
        });

        const { checkbox1Field } = this.props.options;

        this.updateResult(this.isValid(), checkbox1Field, event.target.checked);
    }

    handleCheckbox2Change(event) {
        this.setState({
            randomSeedNumber: this.state.randomSeedNumber,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailAddress: this.state.emailAddress,
            agreedToC1: this.state.agreedToC1,
            agreedToC2: event.target.checked,
            additional1: this.state.additional1,
            additional2: this.state.additional2,
        });

        const { checkbox2Field } = this.props.options;

        this.updateResult(this.isValid(), checkbox2Field, event.target.checked);
    }

    handleAdditional1Change(event) {
        this.setState({
            randomSeedNumber: this.state.randomSeedNumber,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailAddress: this.state.emailAddress,
            agreedToC1: this.state.agreedToC1,
            agreedToC2: this.state.agreedToC2,
            additional1: event.target.value,
            additional2: this.state.additional2,
        });

        const { additionalField1 } = this.props.options;

        this.updateResult(this.isValid(), additionalField1, event.target.value);
    }

    handleAdditional2Change(event) {
        this.setState({
            randomSeedNumber: this.state.randomSeedNumber,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailAddress: this.state.emailAddress,
            agreedToC1: this.state.agreedToC1,
            agreedToC2: this.state.agreedToC2,
            additional1: this.state.additional1,
            additional2: event.target.value,
        });

        const { additionalField2 } = this.props.options;

        this.updateResult(this.isValid(), additionalField2, event.target.value);
    }

    createMarkup = (param) => {
        return { __html: param };
    };

    componentDidUpdate() {
        const { canGoToNextStep } = this.props;

        if (!canGoToNextStep && this.isValid()) {
            this.updateResult(this.isValid());
        }
    }

    focusOnElement = (element) => {
        element.focus();
    };

    render() {
        const { options } = this.props;

        const {
            firstnameLabel,
            firstnameError,
            lastnameLabel,
            lastnameError,
            nameFieldsAreOptional,
            hideNameFields,
            emailLabel,
            emailError,
            checkbox1IsOptional,
            hideCheckbox1,
            checkbox1Label,
            checkbox1Error,
            checkbox2Label,
            checkbox2Error,
            checkbox2IsOptional,
            hideCheckbox2,
            additionalField1Label,
            additionalField1Error,
            additionalField1IsOptional,
            hideAdditionalField1,
            additionalField2Label,
            additionalField2Error,
            additionalField2IsOptional,
            hideAdditionalField2,
        } = options;

        const {
            randomSeedNumber,
            firstName,
            lastName,
            emailAddress,
            agreedToC1,
            agreedToC2,
            additional1,
            additional2,
        } = this.state;

        const { textMaximumLength, viewErrors } = this.props;

        const isFilledFirstname = firstName && firstName.length > 0;
        const isFilledLastname = lastName && lastName.length > 0;
        const isFilledEmail = emailAddress && emailAddress.length > 0;
        const isValidEmail = validateEmail(emailAddress).isValid;
        const isFilledAdditionalField1 = additional1 && additional1.length > 0;
        const isFilledAdditionalField2 = additional2 && additional2.length > 0;

        const checkbox1withRandomSeed = "checkbox1" + randomSeedNumber;
        const checkbox2withRandomSeed = "checkbox2" + randomSeedNumber;

        return (
            <div className="tab">
                <div className="forms">
                    <form className="standard">
                        {hideNameFields !== true && (
                            <div className="nameFields">
                                <div
                                    className={`form-field auto-mt-xs ${
                                        isFilledFirstname
                                            ? "is-filled"
                                            : "is-empty"
                                    }`}
                                >
                                    <input
                                        ref={(input) =>
                                            (this.inputFirstnameElement = input)
                                        }
                                        className="form-field__input"
                                        type="text"
                                        value={firstName}
                                        maxLength={textMaximumLength}
                                        onChange={this.handleFirstnameChange}
                                    />
                                    <label
                                        className="form-field__label"
                                        htmlFor=""
                                        onClick={() =>
                                            this.focusOnElement(
                                                this.inputFirstnameElement
                                            )
                                        }
                                    >
                                        {firstnameLabel}
                                    </label>
                                    {viewErrors &&
                                    !nameFieldsAreOptional &&
                                    !isFilledFirstname ? (
                                        <ul className="form-field__error-list filled">
                                            <li className="form-field__error-item">
                                                {firstnameError}
                                            </li>
                                        </ul>
                                    ) : null}
                                </div>
                                <div
                                    className={`form-field auto-mt-xs ${
                                        isFilledLastname
                                            ? "is-filled"
                                            : "is-empty"
                                    }`}
                                >
                                    <input
                                        ref={(input) =>
                                            (this.inputLastnameElement = input)
                                        }
                                        className="form-field__input"
                                        type="text"
                                        value={lastName}
                                        maxLength={textMaximumLength}
                                        onChange={this.handleLastnameChange}
                                    />
                                    <label
                                        className="form-field__label"
                                        htmlFor=""
                                        onClick={() =>
                                            this.focusOnElement(
                                                this.inputLastnameElement
                                            )
                                        }
                                    >
                                        {lastnameLabel}
                                    </label>
                                    {viewErrors &&
                                    !nameFieldsAreOptional &&
                                    !isFilledLastname ? (
                                        <ul className="form-field__error-list filled">
                                            <li className="form-field__error-item">
                                                {lastnameError}
                                            </li>
                                        </ul>
                                    ) : null}
                                </div>
                            </div>
                        )}

                        {hideAdditionalField1 !== true && (
                            <div
                                className={`form-field auto-mt-xs ${
                                    isFilledAdditionalField1
                                        ? "is-filled"
                                        : "is-empty"
                                }`}
                            >
                                <input
                                    ref={(input) =>
                                        (this.inputAdditional1Element = input)
                                    }
                                    className="form-field__input"
                                    type="text"
                                    value={additional1}
                                    maxLength={textMaximumLength}
                                    onChange={this.handleAdditional1Change}
                                />
                                <label
                                    className="form-field__label"
                                    htmlFor=""
                                    onClick={() =>
                                        this.focusOnElement(
                                            this.inputAdditional1Element
                                        )
                                    }
                                >
                                    {additionalField1Label}
                                </label>
                                {viewErrors &&
                                !additionalField1IsOptional &&
                                !isFilledAdditionalField1 ? (
                                    <ul className="form-field__error-list filled">
                                        <li className="form-field__error-item">
                                            {additionalField1Error}
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                        )}

                        {hideAdditionalField2 !== true && (
                            <div
                                className={`form-field auto-mt-xs ${
                                    isFilledAdditionalField2
                                        ? "is-filled"
                                        : "is-empty"
                                }`}
                            >
                                <input
                                    ref={(input) =>
                                        (this.inputAdditional2Element = input)
                                    }
                                    className="form-field__input"
                                    type="text"
                                    value={additional2}
                                    maxLength={textMaximumLength}
                                    onChange={this.handleAdditional2Change}
                                />
                                <label
                                    className="form-field__label"
                                    htmlFor=""
                                    onClick={() =>
                                        this.focusOnElement(
                                            this.inputAdditional2Element
                                        )
                                    }
                                >
                                    {additionalField2Label}
                                </label>
                                {viewErrors &&
                                !additionalField2IsOptional &&
                                !isFilledAdditionalField2 ? (
                                    <ul className="form-field__error-list filled">
                                        <li className="form-field__error-item">
                                            {additionalField2Error}
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                        )}

                        <div
                            className={`form-field auto-mt-xs ${
                                isFilledEmail ? "is-filled" : "is-empty"
                            }`}
                        >
                            <input
                                ref={(input) =>
                                    (this.inputEmailElement = input)
                                }
                                className="form-field__input"
                                type="email"
                                value={emailAddress}
                                maxLength={textMaximumLength}
                                onChange={this.handleEmailChange}
                            />
                            <label
                                className="form-field__label"
                                htmlFor=""
                                onClick={() =>
                                    this.focusOnElement(this.inputEmailElement)
                                }
                            >
                                {emailLabel}
                            </label>
                            {viewErrors && !isValidEmail ? (
                                <ul className="form-field__error-list filled">
                                    <li className="form-field__error-item">
                                        {emailError}
                                    </li>
                                </ul>
                            ) : null}
                        </div>
                    </form>
                    <div
                        className="terms-and-conditions-information"
                        dangerouslySetInnerHTML={this.createMarkup(
                            options.termsAndConditionsInformation
                        )}
                    />
                    {hideCheckbox1 !== true && (
                        <div className="form-checkbox form-checkbox-panel__container">
                            <input
                                className="form-checkbox__checkbox visually-hidden"
                                id={checkbox1withRandomSeed}
                                type="checkbox"
                                name=""
                                value={agreedToC1}
                                onChange={this.handleCheckbox1Change}
                            />
                            <label
                                className="form-checkbox__label"
                                htmlFor={checkbox1withRandomSeed}
                            >
                                <div
                                    dangerouslySetInnerHTML={this.createMarkup(
                                        checkbox1Label
                                    )}
                                />
                            </label>
                            {viewErrors &&
                            !checkbox1IsOptional &&
                            !agreedToC1 ? (
                                <ul className="form-field__error-list filled">
                                    <li className="form-field__error-item">
                                        {checkbox1Error}
                                    </li>
                                </ul>
                            ) : null}
                        </div>
                    )}
                    {hideCheckbox2 !== true && (
                        <div className="form-checkbox form-checkbox-panel__container">
                            <input
                                className="form-checkbox__checkbox visually-hidden"
                                id={checkbox2withRandomSeed}
                                type="checkbox"
                                name=""
                                value={agreedToC2}
                                onChange={this.handleCheckbox2Change}
                            />
                            <label
                                className="form-checkbox__label"
                                htmlFor={checkbox2withRandomSeed}
                            >
                                <div
                                    dangerouslySetInnerHTML={this.createMarkup(
                                        checkbox2Label
                                    )}
                                />
                            </label>
                            {viewErrors &&
                            !checkbox2IsOptional &&
                            !agreedToC2 ? (
                                <ul className="form-field__error-list filled">
                                    <li className="form-field__error-item">
                                        {checkbox2Error}
                                    </li>
                                </ul>
                            ) : null}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
